import React from "react";
import { Schema } from "@comparaonline/products-schema";
import { Mutation, MutationProps, MutationFn } from "react-apollo";

import { createProductReview } from "../createProductReview";

export interface MutationArgs {
  comment: string;
  userName: string;
  value: number;
  userEmail: string;
  businessUnit: string;
  productId: number;
}

type MutationResponse = Required<Schema.UserReview>;

class BaseMutation extends Mutation<MutationResponse, MutationArgs> {}

type CreateProductReviewMutationProps = Pick<
  MutationProps<MutationResponse, MutationArgs>,
  "children"
>;

export type MutationFunction = MutationFn<MutationResponse, MutationArgs>;

export const CreateProductReviewMutation: React.FC<CreateProductReviewMutationProps> = ({
  children
}) => (
  <BaseMutation mutation={createProductReview}>
    {(mutateFn, data) => children(mutateFn, data)}
  </BaseMutation>
);
